var Expediente = (function () {
    function Expediente(expId, tipo, numero, anio, caratula, organismo, fecha, estado, materia, fecUltMov, destUltMov, nivacc, esFav, monto, secretaria, orgDestino, secDestino, problema, acumuladoEn, organismoActual, fechaHecho, org_activebf, orgId, secId, orgInsRad, cirIdRad, depIdRad, orgMultifueroRad, sedDepIdRad, fueIdRad) {
        this.expId = expId;
        this.tipo = tipo;
        this.numero = numero;
        this.anio = anio;
        this.caratula = caratula;
        this.organismo = organismo;
        this.fecha = fecha;
        this.estado = estado;
        this.materia = materia;
        this.fecUltMov = fecUltMov;
        this.destUltMov = destUltMov;
        this.nivacc = nivacc;
        this.esFav = esFav;
        this.monto = monto;
        this.secretaria = secretaria;
        this.orgDestino = orgDestino;
        this.secDestino = secDestino;
        this.problema = problema;
        this.acumuladoEn = acumuladoEn;
        this.organismoActual = organismoActual;
        this.fechaHecho = fechaHecho;
        this.org_activebf = org_activebf;
        this.orgId = orgId;
        this.secId = secId;
        this.orgInsRad = orgInsRad;
        this.cirIdRad = cirIdRad;
        this.depIdRad = depIdRad;
        this.orgMultifueroRad = orgMultifueroRad;
        this.sedDepIdRad = sedDepIdRad;
        this.fueIdRad = fueIdRad;
    }
    return Expediente;
}());
export { Expediente };
var ExpedientePage = (function () {
    function ExpedientePage(page, size, total, data) {
        this.page = page;
        this.size = size;
        this.total = total;
        this.data = data;
    }
    return ExpedientePage;
}());
export { ExpedientePage };
var ExpedienteFilter = (function () {
    function ExpedienteFilter(fecha_desde, fecha_hasta, caratula, movimiento, favorito, cir_id, org_id, numero, anio, page, size, usrCod) {
        this.fecha_desde = fecha_desde;
        this.fecha_hasta = fecha_hasta;
        this.caratula = caratula;
        this.movimiento = movimiento;
        this.favorito = favorito;
        this.cir_id = cir_id;
        this.org_id = org_id;
        this.numero = numero;
        this.anio = anio;
        this.page = page;
        this.size = size;
        this.usrCod = usrCod;
    }
    return ExpedienteFilter;
}());
export { ExpedienteFilter };
var TiposExpediente = (function () {
    function TiposExpediente(descr, codigo, forcar) {
        this.descr = descr;
        this.codigo = codigo;
        this.forcar = forcar;
    }
    return TiposExpediente;
}());
export { TiposExpediente };
var ExpedienteFilterDownload = (function () {
    function ExpedienteFilterDownload(expId, fecha_desde, fecha_hasta, dac, firmante, descarga_act, con_adjuntos, descarga_zip, con_escritos, fecha_desde_excluir, fecha_hasta_excluir, dac_excluir, firmante_excluir, usrCod) {
        this.expId = expId;
        this.fecha_desde = fecha_desde;
        this.fecha_hasta = fecha_hasta;
        this.dac = dac;
        this.firmante = firmante;
        this.descarga_act = descarga_act;
        this.con_adjuntos = con_adjuntos;
        this.descarga_zip = descarga_zip;
        this.con_escritos = con_escritos;
        this.fecha_desde_excluir = fecha_desde_excluir;
        this.fecha_hasta_excluir = fecha_hasta_excluir;
        this.dac_excluir = dac_excluir;
        this.firmante_excluir = firmante_excluir;
        this.usrCod = usrCod;
    }
    return ExpedienteFilterDownload;
}());
export { ExpedienteFilterDownload };
//# sourceMappingURL=expediente.js.map